module.exports = __webpack_public_path__ + "static/media/lb-banner.05173be0.png";